import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Layout Components
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { ScrollToTop } from "@/components/layout/ScrollToTop";
import { WhatsAppButton } from "@/components/shared/WhatsAppButton";


// Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ConsultPage from "@/pages/ConsultPage";
import DigitalSolutionsPage from "@/pages/DigitalSolutionsPage";
import TrainingPage from "@/pages/TrainingPage";
import ProjectsPage from "@/pages/ProjectsPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import ContactPage from "@/pages/ContactPage";
import EventsPage from "@/pages/EventsPage";
import CCTSTrainingPage from "@/pages/CCTSTrainingPage";
import CarbonCircularLivePage from "@/pages/CarbonCircularLivePage";
import CCTSCheckerPage from "@/pages/CCTSCheckerPage";

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ConsultPage />} />
          <Route path="/services/digital-solutions" element={<DigitalSolutionsPage />} />
          <Route path="/services/training" element={<TrainingPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/events/ccts-training" element={<CCTSTrainingPage />} />
          <Route path="/events/carbon-circular-live" element={<CarbonCircularLivePage />} />
          <Route path="/ccts-checker" element={<CCTSCheckerPage />} />
        </Routes>
        <Footer />
        <WhatsAppButton />

        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
